'use client';

import { BProgress } from '@bprogress/core';
import { ProgressProvider as AppProgressProvider } from '@bprogress/next/app';
import { ReactNode, useEffect } from 'react';

function BProgressBackForwardGuard() {
    useEffect(() => {
        const clearProgress = () => {
            BProgress.remove();
            BProgress.status = null;
        };
        const doneOnBfcacheRestore = (event: PageTransitionEvent) => {
            if (event.persisted) clearProgress();
        };

        window.addEventListener("pagehide", clearProgress);
        window.addEventListener("pageshow", doneOnBfcacheRestore);

        return () => {
            window.removeEventListener("pagehide", clearProgress);
            window.removeEventListener("pageshow", doneOnBfcacheRestore);
        };
    }, []);

    return null;
}


const ProgressBarProvider = ({ children }: { children: ReactNode }) => {
    return (
        <AppProgressProvider
            height="3px"
            disableStyle
            options={{ showSpinner: false, speed: 300 }}>
            <BProgressBackForwardGuard />
            {children}
        </AppProgressProvider>
    );
};

export default ProgressBarProvider;
